import request from '../request'
//收货地
 export function receiveSeach(params,data) { //收货地查询
    return request({
        url: "/dict/receive/search",
        method: "get",
        params,
        data
    })  
}
export function receiveSave(params,data) { //收货地保存
    return request({
        url: "/dict/receive/save",
        method: "post",
        params,
        data
    })  
}
export function receiveUpdate(params,data) { //收货地查询
    return request({
        url: "/dict/receive/update",
        method: "post",
        params,
        data
    })  
}
export function receiveDelete(id) { //收货地删除
    return request({
        url: `/dict/receive/delete/${id}`,
        method: "get",
    })  
}

//发货地
export function sendSeach(params,data) { //发货地查询
    return request({
        url: "/dict/send/search",
        method: "get",
        params,
        data
    })  
}
export function sendSave(params,data) { //发货地保存
    return request({
        url: "/dict/send/save",
        method: "post",
        params,
        data
    })  
}
export function sendUpdate(params,data) { //发货地查询
    return request({
        url: "/dict/send/update",
        method: "post",
        params,
        data
    })  
}
export function sendDelete(id) { //发货地删除
    return request({
        url: `/dict/send/delete/${id}`,
        method: "get",
    })  
}

//品名
export function goodsNameSeach(params,data) { //品名查询
    return request({
        url: "/dict/goods_name/search",
        method: "get",
        params,
        data
    })  
}
export function goodsNameSave(params,data) { //品名保存
    return request({
        url: "/dict/goods_name/save",
        method: "post",
        params,
        data
    })  
}
export function goodsNameUpdate(params,data) { //品名查询
    return request({
        url: "/dict/goods_name/update",
        method: "post",
        params,
        data
    })  
}
export function goodsNameDelete(id) { //品名删除
    return request({
        url: `/dict/goods_name/delete/${id}`,
        method: "get",
    })  
}

